var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeUpArro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6568 6.65685C12.0473 6.26633 12.0473 5.63317 11.6568 5.24264L6.70707 0.292893C6.31654 -0.0976313 5.68338 -0.097631 5.29285 0.292893L0.343105 5.24264C-0.0474195 5.63316 -0.0474195 6.26633 0.343105 6.65685C0.733629 7.04738 1.36679 7.04738 1.75732 6.65685L5.99996 2.41421L10.2426 6.65685C10.6331 7.04738 11.2663 7.04738 11.6568 6.65685Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeUpArro);
export default __webpack_public_path__ + "static/media/time-up-arro.a24df7e4f9a2c48aaf1e22e116195811.svg";
export { ForwardRef as ReactComponent };